<template>
    <div>
        <input type="hidden" name="library_info[info]" :value="editedInfo">
        <vue-editor v-model="editedInfo" :editor-toolbar="customToolbar">
        </vue-editor>
    </div>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
    name: "library-add-extra-info",
    components: {VueEditor},
    props: {
        edited_info: String,
    },
    data() {
        return {
            editedInfo: this.edited_info ?? '',
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                ["blockquote"],
                [{ list: "ordered" }, { list: "bullet" }, {list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }],
                ["clean"]
            ],
        }
    }
}
</script>

<style scoped>

</style>
